export const chartPeriodData = [
  {
    label: "3 Days",
    value: 3,
  },
  {
    label: "This Week",
    value: new Date().getDay(),
  },
  {
    label: "1 Week",
    value: 7,
  },
  {
    label: "2 Weeks",
    value: 14,
  },
  {
    label: "3 Weeks",
    value: 21,
  },
  {
    label: "This Year",
    value:
      Math.round(
        (new Date() - new Date(new Date().getFullYear(), 0, 1)) /
          (1000 * 60 * 60 * 24),
      ) - 1,
  },
  {
    label: "1 Month",
    value: 30,
  },
  {
    label: "3 Months",
    value: 90,
  },
  {
    label: "6 Months",
    value: 180,
  },
  {
    label: "1 Year",
    value: 365,
  },
  {
    label: "All Time",
    value: 72000,
  },
];
